<template>
  <div class="terminal-body" ref="body">
    <command-block
      v-for="(command, index) in currentCommands"
      :key="index"
      @block-complete="nextCommand"
      :username="username"
      :promptIcon="promptIcon"
      :command="command"
      :typeCharDelay="typeCharDelay"
    ></command-block>
    <terminal-command
      :class="defaultPromptClasses"
      :username="username"
      :promptIcon="promptIcon"
      :remainIdle="true"
    ></terminal-command>
  </div>
</template>

<script>
import CommandBlock from "./TerminalCommandBlock";
import TerminalCommand from "./TerminalCommand";

const STATE = {
  IDLE: "idle",
  ACTIVE: "active"
};
//FIXME: start/stop/state is ugly and confusing
export default {
  components: { CommandBlock, TerminalCommand },
  props: {
    promptIcon: String,
    commands: Array,
    username: String,
    typeCharDelay: Number,
    autoStart: { default: true }
  },

  data() {
    return {
      state: this.autoStart ? STATE.ACTIVE : STATE.IDLE,
      nextCommandIndex: 0
    };
  },
  computed: {
    currentCommands() {
      return this.commands.slice(0, this.nextCommandIndex);
    },
    commandsComplete() {
      return this.nextCommandIndex > this.commands.length;
    },
    defaultPromptClasses() {
      return {
        "is-invisible": this.state == STATE.ACTIVE
      };
    }
  },
  mounted() {
    if (this.autoStart) {
      this.start();
    }
  },
  methods: {
    start() {
      this.state = STATE.ACTIVE;
      this.nextCommand();
    },
    stop() {
      this.state = STATE.IDLE;
    },
    scrollToBottom() {
      this.$refs.body.scrollTop = this.$refs.body.scrollHeight;
    },
    nextCommand() {
      if (this.state == STATE.ACTIVE) {
        setTimeout(() => {
          this.nextCommandIndex += 1;
          if (this.commandsComplete) {
            this.state = STATE.IDLE;
          }
          this.scrollToBottom();
        }, 250);
      }
    }
  }
};
</script>
